<script>
	import cssVars from "svelte-css-vars";
	import { beforeUpdate,afterUpdate } from "svelte";

	let contentContainer
	export let autoScroll = false
	let contentScroll = false
	
	beforeUpdate(()=>{
		contentScroll = contentContainer && (contentContainer.offsetHeight + contentContainer.scrollTop) > (contentContainer.scrollHeight - 30);
	})

	afterUpdate(()=>{
		if (autoScroll && contentScroll) contentContainer.scrollTo(0, contentContainer.scrollHeight);
	})

	export let css = {};
	export let title = "Window Title";
	export let top = 10;
	export let left = 10;
	export let width = 300;
	export let height = 460;
	let tmp_height = height
	export let visible = true

	let default_vars = {
		minWidth: "100px",

		minHeight: "60px",
	
		borderColor: "#f1f1f1",
		textColor: "#888",
	};

	let elemContainer;
	let pos_clientX;
	let pos_clientY;

	let win_mousemove = null,
		win_mouseup = null;

	$: _vars = {
		...default_vars,
		...css,
		...{ posX: left + "px", posY: top + "px", 	height: height+"px", width: width+"px"},
	};

	function handleMousedown(e) {
		pos_clientX = e.clientX;
		pos_clientY = e.clientY;

		win_mousemove = dragElement;
		win_mouseup = () => {
			console.log("window on mouseup");
			win_mousemove = win_mouseup = null;
		};
	}

	function dragElement(e) {
		let offsetX = pos_clientX - e.clientX;
		let offsetY = pos_clientY - e.clientY;

		pos_clientX = e.clientX;
		pos_clientY = e.clientY;

		//update container position
		top = top - offsetY;
		left = left - offsetX;

		//if (top < 0) top = 0;
		//if (left < 0) left = 0;
	}

	const toggleSize = () => {
		if(tmp_height == height){
			height = 60
		}
		else {
			height = tmp_height
		}
	}
</script>
<!--
<svelte:body
	on:mousemove={win_mousemove}
	on:touchmove={win_mousemove}
	on:mouseup={win_mouseup}
	on:touchend={win_mouseup}
	on:moueleave={win_mouseup} />
-->
<svelte:body
	on:pointermove={win_mousemove}
	on:pointerup={win_mouseup} />

<div class="container" class:hidden={!visible} use:cssVars={_vars} bind:this={elemContainer}>
	<div class="top"   on:pointerdown={handleMousedown}>
		<span on:click={toggleSize} class="dot" />
		<span class="title"> {title} </span>
	</div>

	<div  bind:this={contentContainer} class="content">
		<slot name="content"></slot>
	</div>
	<div>
		<slot name="bottom"></slot>
	</div>
</div>

<style>
	.hidden {
		display: none;
	}

	.dot {
		height: 12px;
		width: 12px;
		float: right;
		background-color: rgb(66, 66, 66);
		display: inline-block;
		text-align: center;
		user-select: none;
		cursor: pointer;
	}

	.dot:hover {
	    background: #525252;
    	box-shadow: 0px 0px 3px 1px #01dcff;
	}

	.container {
		position: absolute;
		top: var(--posY);
		left: var(--posX);

		border: 2px solid var(--borderColor);
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		border-top-width: 0px;
		min-width: var(--minWidth);
		min-height: var(--minHeight);
		width: var(--width);
		
		box-shadow: 3px 4px 6px 0px rgba(0, 0, 0, 0.3);
	}

	.top {
		font-family: Arial;

		padding: 10px;
		color: var(--textColor);
		background: var(--borderColor);

		border: 2px solid var(--borderColor);
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	.top .title {
		font-weight: 600;
		font-size: 1rem;

		font-style: italic;
		text-shadow: 1px 1px 1px #333;
	}

	.content {
		width: 100%;
		height: var(--height);
		position: relative;
		overflow: auto;
		background-color: #fff;
	}
</style>
